import { render, staticRenderFns } from "./CommonSpeechEvaluating.vue?vue&type=template&id=f9b745c0&scoped=true"
import script from "./CommonSpeechEvaluating.vue?vue&type=script&lang=js"
export * from "./CommonSpeechEvaluating.vue?vue&type=script&lang=js"
import style0 from "./CommonSpeechEvaluating.vue?vue&type=style&index=0&id=f9b745c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b745c0",
  null
  
)

export default component.exports